import map from "rfuncs/functions/map"
import to_array from "rfuncs/functions/to_array"

export default (files, ...args) =>
    Promise.all(map(f => f.wait(...args).then(() => f), to_array(files)))
